import * as React from 'react';
import { FileList } from '../component/filesystem';
import { Page } from '../component/page';

export const FilePage: React.SFC<{ path: string }> = ({ ...rest }) => (
  <Page {...rest}>
    <FileList />
  </Page>
);
